export const config = {
  mixins: [],
  data() {
    return {
      columns: []
    };
  },
  methods: {
    // 获取表格列
    getColumns() {
      let columns = [
        {
          title: '序号',
          align: 'center',
          type: 'index',
          width: 80
        },
        {
          title: '订单编号',
          minWidth: 170,
          align: 'center',
          key: 'id'
        },
        {
          title: '预约编号',
          slot: 'reservationNo',
          minWidth: 140,
          align: 'center'
        },
        {
          title: '兑换商品',
          minWidth: 140,
          align: 'center',
          key: 'svcName'
        },
        {
          title: '客户姓名',
          minWidth: 120,
          align: 'center',
          key: 'customerName'
        },
        {
          title: '消耗积分',
          minWidth: 120,
          align: 'center',
          key: 'commission'
        },
        {
          title: '兑换时间',
          minWidth: 140,
          align: 'center',
          key: 'orderDate',
          render(h, params) {
            const txt = params.row.orderDate;
            return <div>{txt ? txt.substr(0, 16) : ''}</div>;
          }
        },
        {
          title: '状态',
          minWidth: 100,
          align: 'center',
          slot: 'orderState'
        },
        {
          title: '操作',
          align: 'center',
          slot: 'action',
          width: 240,
          fixed: 'right'
        }
      ];
      this.columns = columns;
    }
  }
};
